import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  doUpdateSelectedMentionSelectorAgentId,
  doUpdateSuppressMentionSelector,
} from 'actions/app'
import { doMentionAgent } from 'actions/tickets'

import {
  selectMentionableAgents,
  selectFilteredMentionableAgents,
  selectSuggestedMentionableAgents,
  selectIsMentioningAgent,
  selectAgentMention,
} from 'selectors/mentions'
import { selectModalProps } from 'selectors/modals'
import { selectNoteFormHeight } from 'selectors/tickets'

import MentionModal from './view'

const select = state => ({
  modalProps: selectModalProps(state),
  isOpen: selectIsMentioningAgent(state),
  bottomOffset: selectNoteFormHeight(state),
  sortedAgents: selectMentionableAgents(state),
  suggestedAgents: selectSuggestedMentionableAgents(state),
  filteredAgents: selectFilteredMentionableAgents(state),
  agentMention: selectAgentMention(state),
})

const perform = dispatch => ({
  ...bindActionCreators(
    {
      doUpdateSelectedMentionSelectorAgentId,
      doMentionAgent,
    },
    dispatch
  ),
  close: () => dispatch(doUpdateSuppressMentionSelector(true)),
})

export default connect(select, perform)(MentionModal)
